import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.packageAdd || initialState;

export const selectCompanies = createSelector([selectDomain], (state) =>
  state.companies.map((company) => ({
    label: company.companyName,
    value: company._id,
  }))
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectCatalog = createSelector(
  [selectDomain],
  (state) => state.catalog
);

export const selectTestCategories = createSelector(
  [selectDomain],
  (state) => state.catalog
);

/* export const selectCommodities = createSelector([selectDomain], (state) => {
  const catalog = state.catalog;
  const options = [];
  catalog.forEach((item) => {
    const test = item.test;
    const commodity = test.commodity;
    const commodityCategory = test.commodityCategory;

    const index = options.findIndex(
      (opt) => opt.label === commodityCategory.name
    );
    const commodityOption = { label: commodity.name, value: commodity._id };
    if (index === -1) {
      options.push({
        label: commodityCategory.name,
        options: [commodityOption],
      });
    } else {
      // check if commodity already exists in category
      const optIndex = options[index].options.findIndex(
        (cat) => cat.value === commodity._id
      );
      if (optIndex === -1) {
        options[index].options.push(commodityOption);
      }
    }
  });
  return options;
});
 */

export const selectCommodities = createSelector(
  [selectDomain],
  (state) => state.commodities
);

export const selectTests = createSelector(
  [selectDomain],
  (state) => state.tests
);
